var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{attrs:{"id":"walkabouts"}},[_c('h1',[_vm._v("WEAVING THE FLEECE - FEEDING THE MOLESKINE - DOING THINGS")]),_c('div',{staticClass:"content-wrapper"},[_c('div',[_vm._v("revisiting the banks")])])])
}]

export { render, staticRenderFns }